module.exports = __webpack_public_path__ + "static/fort_static-e882d0445534213e8e2d4c5b153eb5ac.png";